/**
 * Gets a better readable icon name for SVG titles.
 * @param iconName The icon name.
 * @returns The formatted icon name.
 */
export function formatIconName(iconName: string): string {
  if (!iconName || typeof iconName !== 'string') {
    return "";
  }

  return iconName
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
